import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useMultiLayerDrawerEnabledOnce } from '../../hooks/useMultiLayerDrawerEnabledOnce';

export const MultiLayerDrawerContext = createContext({});

export const useMultiLayerDrawerContext = () => useContext(MultiLayerDrawerContext);

export const MultiLayerDrawerProvider = ({ children }) => {
    const [forms, setForms] = useState({});
    const [modulePages, setModulePages] = useState({});
    const [entityData, setEntityData] = useState({});
    const [moduleProviders, setModuleProviders] = useState({});
    const isMultiDrawerEnabledOnce = useMultiLayerDrawerEnabledOnce();

    const registerModuleProviders = useCallback(
        ({ moduleName, provider }) => {
            setModuleProviders(providers => ({
                ...providers,
                [moduleName]: { provider },
            }));
        },
        [setModuleProviders]
    );

    const registerModulePage = useCallback(
        modulePage => {
            setModulePages(modulePages => ({ ...modulePages, [modulePage.path]: { component: modulePage.component } }));
        },
        [setModulePages]
    );

    const registerForm = useCallback(
        form => {
            setForms(forms => ({
                ...forms,
                [form.path]: {
                    ...form,
                },
            }));
        },
        [setForms]
    );

    const value = useMemo(
        () => ({
            forms,
            setForms,
            registerForm,
            modulePages,
            setModulePages,
            registerModulePage,
            entityData,
            setEntityData,
            moduleProviders,
            registerModuleProviders,
            isEnabled: isMultiDrawerEnabledOnce,
        }),
        [
            forms,
            setForms,
            registerForm,
            modulePages,
            registerModulePage,
            entityData,
            setEntityData,
            moduleProviders,
            registerModuleProviders,
            isMultiDrawerEnabledOnce,
        ]
    );

    return <MultiLayerDrawerContext.Provider value={value}>{children}</MultiLayerDrawerContext.Provider>;
};
